import { render, staticRenderFns } from "./GoldEventManage.vue?vue&type=template&id=0d0f2535&scoped=true&"
import script from "./GoldEventManage.vue?vue&type=script&lang=js&"
export * from "./GoldEventManage.vue?vue&type=script&lang=js&"
import style0 from "./GoldEventManage.vue?vue&type=style&index=0&id=0d0f2535&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0f2535",
  null
  
)

export default component.exports